<script setup>
const lang = useI18n().locale.value;

</script>

<template>
  <div ml="8%">
    <div w="95%" mt-24 mb-24>
      <div class="about-warp__right--title">{{ $t('fdzqyxgs') }}</div>
    <div class="about-warp__right--content join-box">
      <div v-if="lang === 'en'" class="join-item">
        <p class="join-title">Forthright Securities Company Limited</p>
        <div class="join-content">
          <p>
            A subsidiary of Forthright Financial Holdings Company Limited ("Forthright Financial") who is a leading provider of investment and financial trading services for our
            customer. Founded in August 2015, Forthright Financial is rapidly developing its new businesses via the establishments of Forthright Securities, Forthright Asset
            Management, Forthright Finance, and Forthright Management Services.
            <br />
            Forthright Securities, a Type 1,Type 2,Type 4 and Type 5 license (CE No: BGP713), is an active participant in HKEX dealing in Securities. With our expertise on the
            latest Financial Technology (FinTech), Research and Customer Services, we committed to provide the high-quality financial services to our clients.
          </p>
          <br />
          <p>To align with our business development, we are now inviting candidates with high calibre to join us for the following positions.</p>
        </div>
        <p class="join-title">Join our Forthright family, and create a better future together</p>
        <div class="join-content">
          <p>Become an employee of Forthright Securities,</p>
          <p>You will be facing challenges and opportunities constantly;</p>
          <p>You will be proud of your self-improvement;</p>
          <p>You will work with the company to realize dual ideals in material and spiritual aspects.</p>
        </div>
        <p class="join-title mb29">Recruiting positions</p>
         <div v-for="(item,index) in joindata" :key="index">
            <p class="join-title mt29">{{item.job_title}}</p>
            <div class="introduceDiv">
              <span>Release date：{{item.publish_date}}</span>
              <div class="right_font" @click="toResume(item.id)">查看详情</div>
            </div>
        </div>
      </div>
      <div v-else-if="lang === 'hk'" class="join-item">
        <p class="join-title">方德證券有限公司 （簡稱“方德證券”)</p>
        <div class="join-content">
          <p>
            方德金融控股有限公司（“方德金控”）的子公司，為我們的客戶提供領先的投資和金融交易服務。
            方德證券成立於2015年8月，方德金控通過成立方德證券，方德資產管理，方德財務和方德管理服務來迅速發展我們的新業務。
            <br />
            方德證券是香港證監會認可的持牌法團，持有香港證監會第1，2，4和5類牌照（中央編號.：BGP713），亦是香港交易所證券交易的積極參與者。
            憑藉我們的最新金融技術，以及研究和客戶服務方面的專業知識，致力為客戶提供優質的金融服務。
          </p>
          <br />
          <p>以配合業務發展，我們現邀請高素質的應聘者加入我們，擔任以下職務:</p>
        </div>
        <p class="join-title">加入方德，共創未來</p>
        <div class="join-content">
          <p>成為方德證券員工，</p>
          <p>您將面對不斷的挑戰和機遇；</p>
          <p>您將為自我能力的提升感到驕傲；</p>
          <p>您將和公司一起實現關於物質和精神的雙重理想！</p>
        </div>
        <p class="join-title mb29">正在招聘職位</p>
        <div v-for="(item,index) in joindata" :key="index">
            <p class="join-title mt29">{{item.job_title}}</p>
            <div class="introduceDiv">
              <span>發布日期：{{item.publish_date}}</span>
              <div class="right_font" @click="toResume(item.id)">查看详情</div>
            </div>
        </div>
      </div>
      <div v-else class="join-item">
        <p class="join-title">方德证券有限公司（简称“方德证券”）</p>
        <div class="join-content">
          <p>
            方德金融控股有限公司（“方德金控”）的子公司，为我们的客户提供领先的投资和金融交易服务。
            方德证券成立于2015年8月，方德金控通过成立方德证券，方德资产管理，方德财务和方德管理服务来迅速发展我们的新业务。
            <br />
            方德证券是香港证监会认可的持牌法团，持有香港证监会第1，2，4和5类牌照（中央编号.:BGP713），亦是香港交易所证券交易的积极参与者。凭借我们的最新金融技术，以及研究和客户服务方面的专业知识，致力为客户提供优质的金融服务。
          </p>
          <br />
          <p>以配合业务发展，我们现邀请高素质的应聘者加入我们，担任以下职务：</p>
        </div>
        <p class="join-title">加入方德，共创未来</p>
        <div class="join-content">
          <p>成为方德证券员工，</p>
          <p>您将面对不断的挑战和机遇；</p>
          <p>您将为自我能力的提升感到骄傲；</p>
          <p>您将和公司一起实现关于物质和精神的双重理想！</p>
        </div>
        <p class="join-title mb29">正在招聘职位</p>
        <div v-for="(item,index) in joindata" :key="index">
            <p class="join-title mt29">{{item.job_title}}</p>
            <div class="introduceDiv">
              <span>发布日期：{{item.publish_date}}</span>
              <div class="right_font" @click="toResume(item.id)">查看详情</div>
            </div>
        </div>
      </div>
      <!-- <div class="post-item">
        <div class="post-item__title">
          <p class="post-item__title--name">{{$t('jqqd')}}</p>
        </div>
      </div> -->
    </div>
    </div>

  </div>
</template>
<style lang="less" scoped>
@import "../../assets/less/main.less";
@import "../assets/css/about.less";
.introduceDiv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  padding-bottom: 30px;
  border-bottom: 1px solid #E6E9ED;
  color: #61676b;

  .right_font {
    color: #d54745;
    font-size: 14px;
    cursor: pointer;
  }
}
.join-box {
  padding-bottom: 20px;
  .bold {
    font-weight: 600;
  }

  .mark {
    background: #f8e0e0;

    a {
      color: #61676b;
      text-decoration: underline;
    }
  }

  .join-item {
    // border-bottom: 1px solid #e6e9ed;

    .join-title {
      color: #0d0e14;
      margin-bottom: 10px;
      .font-size-line(20, 28);
    }

    .join-content {
      color: #61676b;
      margin-bottom: 30px;
      p{
        line-height: 24px;
      }
      .font-size-line(14, 20);
    }
  }

  .post-item {
    padding-top: 29px;
    padding-bottom: 29px;
    border-bottom: 1px solid #e6e9ed;

    &__title {
      &--name {
        .font-size-line(20, 28);
        color: #0d0e14;
        margin-bottom: 10px;
      }

      &--message {
        .font-size-line(12, 17);
        color: #61676b;
      }
    }

    &__content {
      &--title {
        .font-size-line(14, 20);
        color: #1d2228;
        margin-top: 20px;
        margin-bottom: 10px;
      }

      &--list {
        li {
          .font-size-line(12, 17);
          color: #61676b;
        }
      }

      &--tips {
        .font-size-line(14, 20);
        color: #1d2228;
        margin-top: 10px;
        margin-bottom: 20px;
      }

      &--apply {
        color: #61676b;
        .font-size-line(12, 17);

        .apply-btn {
          display: inline-block;
          width: 110px;
          text-align: center;
          color: #ffffff;
          background: rgba(212, 63, 56, 1);
          border-radius: 2px;
          line-height: 32px;
          margin-right: 7px;

          a {
            display: inline-block;
            width: 100%;
            height: 100%;
            color: #ffffff;
          }
        }
      }
    }
  }

  .tips {
    padding: 35px 0 30px 0;
    color: #61676b;
    .font-size-line(12, 17);
  }
}
.mt29{
  margin-top: 29px;
}
.mb29{
  margin-bottom: 29px !important;
}
</style>
